<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
	import { mapState ,mapMutations} from 'vuex'
export default {
  name: 'App',
  created(){
			this.changeUser({wno:this.$route.query.wno});
		},
		methods:{
			...mapMutations(['changeUser']),
		}
}
</script>

<style>
body{
	width: 100%;
	height: 100%;
}
#app {
	position: absolute;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*overflow: hidden;*/
  color: #2c3e50;
  width:1920px;
	height:100%;
	overflow: hidden;
	background:linear-gradient(88deg,rgba(198,198,198,1) 0%,rgba(230,230,230,1) 47%,rgba(222,222,222,1) 100%);
}
.dialogImg>.el-carousel{
	width: 80%;
	height: 100%;
}
.dialogImg>.el-carousel>.el-carousel__container>.el-carousel__item{
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}
.dialogImg>.el-carousel>.el-carousel__container{
	height: 100%;
}
.dialogImg>.el-carousel>.el-carousel__container>.el-carousel__item>img{
	height: 800px;
}
.dialogImg>.el-carousel>.el-carousel__indicators{
	display: none;
}
.el-carousel__arrow{
	width:63px !important;
	height:63px !important;
	overflow: hidden;
}
.el-carousel__arrow:hover{
	background-color:transparent ;
}
.el-carousel__arrow>i{
	display: none;
}
/*.el-carousel__arrow--left{
	background: url(./assets/image/imgleft.png) no-repeat top center;
	background-size:110% ;
}
.el-carousel__arrow--right{
	background: url(./assets/image/imgright.png) no-repeat top center;
	background-size:120% ;
}*/
.fzyyyear-month>div{
		height: 50px;
		width: 93px !important;
	}
	.fzyyyear-month>div>.el-input-number{
		height: 50px;
		width: 93px !important;
	}
	.fzyyyear-month>div>.el-input-number>.el-input{
		height: 50px;
		background: rgba(255, 255, 255, 1);
		border-radius: 10px;
		font-size:18px;
		font-family:PingFangSC-Medium;
		font-weight:500;
		color:rgba(155,155,155,1);
		line-height:23px;
	}
	.fzyyyear-month>div>.el-input-number>.el-input>.el-input__inner{
		padding: 0 10px  !important;
		text-align: left;
		background: rgba(255, 255, 255, 1);
		border-radius: 10px;
		height: 50px;
		color: #9B9B9B !important;
	}
	.fzyyyear-month>div>.el-input-number>span{
		background: none;
		border: none !important;
		width: 40px;
	}
	.fzyyyear-month>div>.el-input-number>span>i{
		font-size: 25px;
	}
	.fzyyyear-month>div>.el-input-number>span.el-input-number__increase{
		right: 0;
		top: 20px;
	}
	.fzyyyear-month>div>.el-input-number>span.el-input-number__decrease{
		right: 0;
		bottom: 20px;
	}
	.fzyyyear-month>div>.el-input-number>span.el-input-number__increase>i::before{
		color: #788995 !important;
		content:"\e790";
	}
	.fzyyyear-month>div>.el-input-number>span.el-input-number__decrease>i::before{
		color: #788995 !important;
		content:"\e78f";
	}
	.month>.fzyyyear-month:nth-child(2)>div>.el-input-number{
		width: 93px !important;
	}
	.month>.numyear>div>.el-input-number{
		width: 93px !important;
	}
	.numyear>div>.el-input-number>.el-input{
		width: 93px;
	}
	.numyear>div>.el-input-number>.el-input>.el-input__inner{
		width: 93px;
	}
	.nummouth>div>.el-input-number{
		width: 72px;
	}
	.nummouth>div>.el-input-number>.el-input{
		width: 72px;
	}
	.nummouth>div>.el-input-number>.el-input>.el-input__inner{
		width: 72px;
		color: #9B9B9B;
	}
	.nummouth>div{
		height: 50px;
	}
	.nummouth>div>.el-input-number{
		font-weight:500 !important;
		height: 50px;
	}
	.nummouth>div>.el-input-number>.el-input{
		height: 50px;
		background: rgba(255, 255, 255, 1);
		border-radius: 10px;
		font-size:18px;
		font-family:PingFangSC-Medium;

		color:rgba(155,155,155,1);
		line-height:23px;
	}
	.nummouth>div>.el-input-number>.el-input>.el-input__inner{
		padding: 0 10px  !important;
		text-align: left;
		background: rgba(255, 255, 255, 1);
		border-radius: 10px;
		height: 50px;
	}
	.nummouth>div>.el-input-number>span{
		background: none;
		border: none !important;
		width: 40px;
	}
	.nummouth>div>.el-input-number>span>i{
		font-size: 25px;
	}
	.nummouth>div>.el-input-number>span.el-input-number__increase{
		right: 0;
		top: 20px;
	}
	.nummouth>div>.el-input-number>span.el-input-number__decrease{
		right: 0;
		bottom: 20px;
	}
	.nummouth>div>.el-input-number>span.el-input-number__increase>i::before{
		content:"\e790";
		color: #788995 !important;
		
	}
	.nummouth>div>.el-input-number>span.el-input-number__decrease>i::before{
		content:"\e78f";
		color: #788995 !important;
	}
	.nummouth>div>.el-input-number>span.el-input-number__increase.is-disabled>i::before{
		color: #C0C4CC !important;
	}
	.nummouth>div>.el-input-number>span.el-input-number__decrease.is-disabled>i::before{
		color: #C0C4CC !important;
	}
	.el-input-number{
		width: 100%;
	}
	
</style>



// WEBPACK FOOTER //
// src/App.vue